const taxRate = 0.13;
export default taxRate;